/* eslint-disable no-useless-escape */
export const NAME_VALIDATION = /^\s*([A-Za-z]{1,}([.,] |[-']| )?)+[A-Za-z]+\.?\s*$/;

//Allow only alphabets
export const FR_NAME_VALIDATION =
  /^\s*(?![\d\s])((?:[A-Za-z]{1,}([.,] |[-']| )?)+[A-Za-z]+\.?)\s*$/;

export const EMAIL_VALIDATION =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// valid phone examples: +447222555555 | +44 7222 555 555 | 07222555555 | 07222 555 555 | (0722) 5555555 #2222 | 0722 5555555 #2222
export const UK_PHONE_VALIDATION =
  /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$/;

export const FR_PHONE_VALIDATION = /^(?:\+33|0)\s*[1-9](?:\s*\d){8}$/;

// valid phone examples: +491234567890 | +49 123 456 7890 | 01234567890 | 0123 456 7890
export const DE_PHONE_VALIDATION = /^(?:\+49|0)\s*[1-9](?:\s*\d){9,10}$/;

// valid phone examples: 12345 | 123 45 | 1234 5
export const NON_ZERO_MIN_5_DIGITS = /^[1-9](?:\s*\d){4,}$/;

export const CONCIERGE_ACTIVATION_TOKEN_VALIDATION = /(^hey-[A-Za-z\d]{6}$)/;

export const NUMBER_VALIDATION_8 = /[0-9]{8}/;

export const NUMBER_VALIDATION_MAX_15 = /^[0-9]{1,15}$/;

export const SIMPLE_NUMBER_VALIDATION = /[0-9]+/;

// with or without hyphens. 112233 || 11-22-33
export const SORT_CODE = /^([0-9]){6}$|^([0-9]){2}([-])([0-9]){2}([-])([0-9]){2}$/;

// UK drivers licence. first 5 chars are letters or 9s, followed buy 11 char alphanumeric
export const UK_DRIVERS_LICENCE = /^([A-Za-z|9]){5}([A-Za-z|0-9]){11}$/;

export const VWFS_NAME_REGEX = /^[a-zA-Z\u00c0-\u018d-][a-zA-Z\u00c0-\u018d\- \n]*$/i;

// Number plate RegEx from gov.uk (does not accept spaces unfortunately so we need to remove them)
export const NUMBER_PLATE_REGEX =
  /(^[A-Z]{2}[0-9]{2}\s?[A-Z]{3}$)|(^[A-Z][0-9]{1,3}[A-Z]{3}$)|(^[A-Z]{3}[0-9]{1,3}[A-Z]$)|(^[0-9]{1,4}[A-Z]{1,2}$)|(^[0-9]{1,3}[A-Z]{1,3}$)|(^[A-Z]{1,2}[0-9]{1,4}$)|(^[A-Z]{1,3}[0-9]{1,3}$)|(^[A-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)/i;

export const FR_NUMBER_PLATE_REGEX = /^[A-Z]{2}-\d{3}-[A-Z]{2}$/;

export const UK_POSTCODE_REGEX = /^[a-z]{1,2}\d[a-z\d]?\s*\d[a-z]{2}$/i;

export const DE_FR_DEALER_ID =
  /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/;

// Password min 8 chars, max 30, needs at least 1 number, 1 symbol, 1 upper case, 1 lower case
export const PASSWORD =
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[ !"#$%&'()*+,-./:;<=>?@[\]^_])(?=.*[a-zA-Z]).{8,30}$/;

// https://regex101.com/r/S0gY8o/2 - EU VAT number validation
export const EU_VAT_NUMBER_REGEX =
  /^((AT)(U\d{8})|(BE)(0\d{9})|(BG)(\d{9,10})|(CY)(\d{8}[LX])|(CZ)(\d{8,10})|(DE)(\d{9})|(DK)(\d{8})|(EE)(\d{9})|(EL|GR)(\d{9})|(ES)([\dA-Z]\d{7}[\dA-Z])|(FI)(\d{8})|(FR)([\dA-Z]{2}\d{9})|(HU)(\d{8})|(IE)(\d{7}[A-Z]{2})|(IT)(\d{11})|(LT)(\d{9}|\d{12})|(LU)(\d{8})|(LV)(\d{11})|(MT)(\d{8})|(NL)(\d{9}(B\d{2}|BO2))|(PL)(\d{10})|(PT)(\d{9})|(RO)(\d{2,10})|(SE)(\d{12})|(SI)(\d{8})|(SK)(\d{10}))$/gim;
